import { useEffect, useMemo, useState } from 'react'
import {
  TuorialBox,
  Mask,
  Popover,
  Arrow,
  HelpMask,
  StartTuorialBtn,
  NoThanksButton,
  TuorialBoxTitle,
  TuorialBoxHelpText,
  TuorialBoxFooter,
  StepTitle,
  StepIntro,
  StepLink,
  Close,
  StepFooter,
  StepBackButton,
  StepNextButton,
  StepDesc,
  StepColumnList,
  ColorBid,
  ColorAsk,
  StepColumnItem,
  ColorNormal,
  ColorMain,
  StepColumnWrapItem,
  StyledSvgAnchor,
} from './styles'
import { FlexBetween, FlexStart } from 'styles'
import { ReactComponent as SvgClose } from './arrow.svg'
import { debounce } from 'lodash'
import {
  getDomRectPos,
  ELEMENT_ID_LIST,
  bringInView,
  getElement,
  LINK,
} from './uitls'
import { useWeb3Connected } from 'store/web3/hooks'
import { useIsActivated } from 'store/account/hooks'

interface IAnchor {
  top: number
  left: number
  bottom: number
  width: number
  height: number
  right: number
  centerX: number
  centerY: number
}

export const UserGuide = () => {
  const [anchorRectPosList, setAnchorRectPosList] = useState<IAnchor[]>([])
  const [step, setStep] = useState(0)
  const [showGuide, setShowGuide] = useState(false)
  const web3Connected = useWeb3Connected()
  const isActivated = useIsActivated()

  const handleClose = () => {
    localStorage.setItem('zkex_v3_guide_spot', '1')
    setShowGuide(false)
  }

  useEffect(() => {
    const GUIDE_SPOT = localStorage.getItem('zkex_v3_guide_spot')
    if (web3Connected && isActivated && !GUIDE_SPOT) {
      setShowGuide(true)
    }
  }, [web3Connected, isActivated])

  const handleCalcElemntsPos = () => {
    const list: Array<IAnchor> = []
    try {
      ELEMENT_ID_LIST.forEach((id) => {
        const dom = getElement(id) as HTMLElement
        if (dom) {
          const style = getDomRectPos(dom)
          list.push(style)
        } else {
          throw new Error(`id: ${id} dom dose not exit`)
        }
      })
      setAnchorRectPosList(list)
    } catch (e) {
      console.error(e)
    }
  }

  useEffect(() => {
    const nav_wrap = getElement('zk_nav_wrap') as HTMLElement
    const spot_wrap = getElement('zk_spot_wrap') as HTMLElement
    if (showGuide) {
      nav_wrap.style.position = 'relative'
      spot_wrap.style.padding = '0px 0px 24px'
    } else {
      nav_wrap.style.position = 'fixed'
      spot_wrap.style.padding = '64px 0 24px'
    }
  }, [showGuide])

  // realtime computing position
  useEffect(() => {
    const debouncedHandle = debounce(handleCalcElemntsPos)
    window.addEventListener('resize', debouncedHandle, false)

    return () => window.removeEventListener('resize', debouncedHandle)
  }, [])

  useEffect(() => {
    const nav_wrap = getElement('zk_nav_wrap') as HTMLElement
    const spot_wrap = getElement('zk_spot_wrap') as HTMLElement
    setTimeout(() => {
      handleCalcElemntsPos()
    }, 500)
    return () => {
      nav_wrap.style.position = 'fixed'
      spot_wrap.style.padding = '64px 0 24px'
    }
  }, [])

  const stepRectPos = useMemo(() => {
    if (anchorRectPosList.length > 0) {
      return anchorRectPosList[step] as IAnchor
    }
    // @ts-ignore
    return {} as IAnchor
  }, [anchorRectPosList, step])

  useEffect(() => {
    bringInView(ELEMENT_ID_LIST[step])
  }, [stepRectPos, step])

  const CloseBtn = () => {
    return <Close onClick={() => handleClose()} />
  }

  const renderStepButton = () => {
    const _next = canNext(step)
    const _back = canBack(step)
    return (
      <StepFooter>
        <StepBackButton
          className={_back ? 'active' : ''}
          onClick={() => {
            if (_back) {
              setStep(step - 1)
            }
          }}
        >
          <SvgClose />
          Back
        </StepBackButton>
        {step !== 10 && (
          <StepNextButton
            className={_next ? 'active' : ''}
            onClick={() => {
              if (_next) {
                setStep(step + 1)
              }
            }}
          >
            Next
            <SvgClose />
          </StepNextButton>
        )}

        {step === 10 && (
          <StepNextButton
            className="finished"
            onClick={() => {
              handleClose()
              // setStep(step + 1)
            }}
          >
            Finished!
          </StepNextButton>
        )}
      </StepFooter>
    )
  }

  const canBack = (currStep: number) => {
    if (currStep <= 1) {
      return false
    }
    return true
  }

  const canNext = (currStep: number) => {
    if (currStep < 10) {
      return true
    }
    return false
  }

  // Guide Steps
  const GUIDE_STEPS = [
    {
      popover: (currRectPos: IAnchor) => {
        return (
          <>
            <Popover
              style={{
                top: currRectPos?.bottom + 15,
                left: currRectPos?.centerX - 180,
              }}
            >
              <Arrow className="top"></Arrow>
              <TuorialBox>
                <TuorialBoxTitle>
                  Welcome! If you are a beginner trader, we have a guided
                  tutorial to help you get started!
                </TuorialBoxTitle>
                <TuorialBoxHelpText>
                  Tutorials can be accessed in Help & Support
                </TuorialBoxHelpText>
                <TuorialBoxFooter>
                  <NoThanksButton onClick={() => handleClose()}>
                    No Thanks
                  </NoThanksButton>
                  <StartTuorialBtn
                    onClick={() => {
                      setStep(step + 1)
                      // localStorage.setItem('zkex_v3_guide_spot', '1')
                    }}
                  >
                    Start Tuorial
                  </StartTuorialBtn>
                </TuorialBoxFooter>
              </TuorialBox>
            </Popover>
          </>
        )
      },
    },
    // {
    //   popover: (currRectPos: IAnchor) => {
    //     return (
    //       <>
    //         <Popover
    //           style={{
    //             top: currRectPos?.bottom + 15,
    //             left: currRectPos?.centerX - 180,
    //           }}
    //         >
    //           <Arrow className="top"></Arrow>
    //           <StepOneBox>
    //             <FlexBetween>
    //               <FlexStart>
    //                 <StepTitle>Connect Your Wallet</StepTitle>
    //                 <StepIntro>(1/10)</StepIntro>
    //               </FlexStart>
    //               <CloseBtn />
    //             </FlexBetween>
    //             <StepOneDesc>
    //               Your wallet is your account! We use it to facilitate smooth
    //               interactions with ZKEX smart contracts.
    //             </StepOneDesc>
    //             <StepLink href={LINK[0]} target="_blank">
    //               Learn more about wallets
    //             </StepLink>
    //             {renderStepButton()}
    //           </StepOneBox>
    //         </Popover>
    //       </>
    //     )
    //   },
    // },
    // {
    //   popover: (currRectPos: IAnchor) => {
    //     return (
    //       <Popover
    //         style={{
    //           top: currRectPos.bottom + 15,
    //           left: currRectPos.centerX - 280,
    //         }}
    //       >
    //         <Arrow className="top" style={{ left: '80%' }}></Arrow>
    //         <StepOneBox>
    //           <FlexBetween>
    //             <FlexStart>
    //               <StepTitle>Select NetWork</StepTitle>
    //               <StepIntro>(2/10)</StepIntro>
    //             </FlexStart>
    //             <CloseBtn />
    //           </FlexBetween>
    //           {/* <StepDesc>
    //             Click to switch between 15 integrated networks.
    //           </StepDesc> */}
    //           <StepTwoNetsList>
    //             {supportChains?.map((item) => {
    //               return (
    //                 <NetworkOption key={item.chainId}>
    //                   <NetworkIcon src={item.iconUrl} />
    //                   <TextOverFlow>{item.name}</TextOverFlow>
    //                 </NetworkOption>
    //               )
    //             })}
    //           </StepTwoNetsList>
    //           <StepLink href={LINK[1]} target="_blank">
    //             Learn more about networks
    //           </StepLink>
    //           {renderStepButton()}
    //         </StepOneBox>
    //       </Popover>
    //     )
    //   },
    // },
    {
      popover: (currRectPos: IAnchor) => {
        return (
          <Popover
            style={{
              top: currRectPos.bottom - 30,
              left: currRectPos.right + 30,
            }}
          >
            <Arrow className="left"></Arrow>
            <TuorialBox>
              <FlexBetween>
                <FlexStart>
                  <StepTitle>Choose Pair</StepTitle>
                  <StepIntro>(1/10)</StepIntro>
                </FlexStart>
                <CloseBtn />
              </FlexBetween>
              <StepDesc>
                Select your trading pair from the drop-down list.
              </StepDesc>
              {renderStepButton()}
            </TuorialBox>
          </Popover>
        )
      },
    },
    {
      popover: (currRectPos: IAnchor) => {
        return (
          <Popover
            style={{ top: currRectPos.top, left: currRectPos.right + 20 }}
          >
            <Arrow className="left"></Arrow>
            <TuorialBox>
              <FlexBetween>
                <FlexStart>
                  <StepTitle>Analyze Trading Charts</StepTitle>
                  <StepIntro>(2/10)</StepIntro>
                </FlexStart>
                <CloseBtn />
              </FlexBetween>
              <StepDesc>
                Elegant and practical candlestick charts covering intervals from
                minutes to months.
              </StepDesc>
              {renderStepButton()}
            </TuorialBox>
          </Popover>
        )
      },
    },
    {
      popover: (currRectPos: IAnchor) => {
        return (
          <Popover
            style={{ top: currRectPos.top, left: currRectPos.left - 360 }}
          >
            <Arrow className="right" style={{ top: '100px' }}></Arrow>
            <TuorialBox>
              <FlexBetween>
                <FlexStart>
                  <StepTitle>Understand Order Book</StepTitle>
                  <StepIntro>(3/10)</StepIntro>
                </FlexStart>
                <CloseBtn />
              </FlexBetween>
              <StepColumnList>
                <StepColumnItem>
                  <ColorBid>· Bid: </ColorBid>
                  <ColorNormal>List of prices for buying assets.</ColorNormal>
                </StepColumnItem>
                <StepColumnItem>
                  <ColorAsk>· Ask: </ColorAsk>
                  <ColorNormal>List of prices for selling assets..</ColorNormal>
                </StepColumnItem>
                <StepColumnItem>
                  <ColorNormal>
                    · The current market price is displayed in the middle.
                  </ColorNormal>
                </StepColumnItem>
              </StepColumnList>
              {renderStepButton()}
            </TuorialBox>
          </Popover>
        )
      },
    },
    {
      popover: (currRectPos: IAnchor) => {
        return (
          <Popover
            style={{ top: currRectPos.top, left: currRectPos.left - 365 }}
          >
            <Arrow className="right"></Arrow>
            <TuorialBox>
              <FlexBetween>
                <FlexStart>
                  <StepTitle>Decide on Trading Direction</StepTitle>
                  <StepIntro>(4/10)</StepIntro>
                </FlexStart>
                <CloseBtn />
              </FlexBetween>
              <StepDesc>For example, in the WBTC/USDC trading pair:</StepDesc>
              <StepColumnList style={{ marginTop: '5px' }}>
                <StepColumnItem>
                  <ColorBid>· Buy: </ColorBid>
                  <ColorNormal>Use USDC to buy WBTC.</ColorNormal>
                </StepColumnItem>
                <StepColumnItem>
                  <ColorAsk>· Sell: </ColorAsk>
                  <ColorNormal>Sell WBTC to get USDC.</ColorNormal>
                </StepColumnItem>
              </StepColumnList>
              {renderStepButton()}
            </TuorialBox>
          </Popover>
        )
      },
    },
    {
      popover: (currRectPos: IAnchor) => {
        return (
          <Popover
            style={{ top: currRectPos.top, left: currRectPos.left - 360 }}
          >
            <Arrow className="right"></Arrow>
            <TuorialBox>
              <FlexBetween>
                <FlexStart>
                  <StepTitle>Decide on Trading Direction</StepTitle>
                  <StepIntro>(5/10)</StepIntro>
                </FlexStart>
                <CloseBtn />
              </FlexBetween>
              <StepColumnList>
                <StepColumnWrapItem>
                  <ColorMain>· Limit: </ColorMain>
                  <ColorNormal>
                    An order to buy or sell at a specific price or better.
                  </ColorNormal>
                </StepColumnWrapItem>
                <StepColumnWrapItem>
                  <ColorMain>· Market: </ColorMain>
                  <ColorNormal>
                    An order to promptly buy or sell at the best price in the
                    current market.
                  </ColorNormal>
                </StepColumnWrapItem>
                <StepColumnWrapItem>
                  <ColorMain>· Stop Limit: </ColorMain>
                  <ColorNormal>
                    When the market price reaches the stop price, a Limit order
                    is automatically executed.
                  </ColorNormal>
                </StepColumnWrapItem>
                <StepColumnWrapItem>
                  <ColorMain>· Stop Market: </ColorMain>
                  <ColorNormal>
                    When the market price reaches the stop price, a market order
                    is automatically executed.
                  </ColorNormal>
                </StepColumnWrapItem>
              </StepColumnList>
              {renderStepButton()}
            </TuorialBox>
          </Popover>
        )
      },
    },
    {
      popover: (currRectPos: IAnchor) => {
        return (
          <Popover
            style={{
              top: currRectPos.top,
              left: currRectPos.left - 360,
            }}
          >
            <Arrow className="right"></Arrow>
            <TuorialBox>
              <FlexBetween>
                <FlexStart>
                  <StepTitle>Adjust Your Leverage</StepTitle>
                  <StepIntro>(6/10)</StepIntro>
                </FlexStart>
                <CloseBtn />
              </FlexBetween>
              <StepDesc>Choose Investing Amount.</StepDesc>
              {renderStepButton()}
            </TuorialBox>
          </Popover>
        )
      },
    },
    {
      popover: (currRectPos: IAnchor) => {
        return (
          <Popover
            style={{ top: currRectPos.top, left: currRectPos.left - 360 }}
          >
            <Arrow className="right"></Arrow>
            <TuorialBox>
              <FlexBetween>
                <FlexStart>
                  <StepTitle>Confirm Trading Details</StepTitle>
                  <StepIntro>(7/10)</StepIntro>
                </FlexStart>
                <CloseBtn />
              </FlexBetween>
              <StepDesc>
                Confirm Fees and Minimum Received token amounts before you
                submit.
              </StepDesc>
              <StepLink href={LINK[2]} target="_blank">
                See more about fees here
              </StepLink>
              {renderStepButton()}
            </TuorialBox>
          </Popover>
        )
      },
    },
    {
      popover: (currRectPos: IAnchor) => {
        return (
          <Popover
            style={{ top: currRectPos.top, left: currRectPos.left - 360 }}
          >
            <Arrow className="right"></Arrow>
            <TuorialBox>
              <FlexBetween>
                <FlexStart>
                  <StepTitle>Cloose Post Only</StepTitle>
                  <StepIntro>(8/10)</StepIntro>
                </FlexStart>
                <CloseBtn />
              </FlexBetween>
              <StepDesc>
                This function ensures your order will be processed as a maker
                order only. It will be automatically canceled if it meets the
                conditions of a taker order.
              </StepDesc>
              {renderStepButton()}
            </TuorialBox>
          </Popover>
        )
      },
    },
    {
      popover: (currRectPos: IAnchor) => {
        return (
          <Popover
            style={{ top: currRectPos.top, left: currRectPos.left - 360 }}
          >
            <Arrow className="right"></Arrow>
            <TuorialBox>
              <FlexBetween>
                <FlexStart>
                  <StepTitle>Execute Your Trade</StepTitle>
                  <StepIntro>(9/10)</StepIntro>
                </FlexStart>
                <CloseBtn />
              </FlexBetween>
              <StepDesc>
                Submit your trade request to the blockchain. Remember to sign in
                your wallet to validate your transactions.
              </StepDesc>

              <StepLink href={LINK[3]} target="_blank">
                Learn more about trades
              </StepLink>
              {renderStepButton()}
            </TuorialBox>
          </Popover>
        )
      },
    },
    {
      popover: (currRectPos: IAnchor) => {
        return (
          <Popover
            style={{ top: currRectPos.top, left: currRectPos.right + 20 }}
          >
            <Arrow className="left"></Arrow>
            <TuorialBox>
              <FlexBetween>
                <FlexStart>
                  <StepTitle>Monitor Your Active Trades</StepTitle>
                  <StepIntro>(10/10)</StepIntro>
                </FlexStart>
                <CloseBtn />
              </FlexBetween>
              <StepDesc>
                Keep track of your trading activities. Stay updated with your
                active trades and orders to make informed decisions. This is
                where you can update your positions as well.
              </StepDesc>
              {renderStepButton()}
            </TuorialBox>
          </Popover>
        )
      },
    },
  ]

  const AnchorElement = ({
    list,
    step,
  }: {
    list: Array<IAnchor>
    step: number
  }) => {
    const _list = list.slice(1) // delete start and frist  step
    const _light = step >= 2 ? 0 : 1
    return (
      <>
        {_list.length &&
          _list.map((d, i) => {
            return (
              <StyledSvgAnchor
                light={_light}
                key={i + 1}
                onClick={() => {
                  setStep(i + 1)
                }}
                style={{
                  left: d?.centerX,
                  top: d?.centerY - 10,
                  display: step === i + 1 ? 'none' : 'block',
                }}
              />
            )
          })}
      </>
    )
  }

  const maskHeight = (document.querySelector('#root') as HTMLElement)
    .clientHeight
  return (
    <>
      {showGuide && step > 0 && (
        <Mask height={maskHeight}>
          {step >= 0 && stepRectPos.width > 0 && (
            <HelpMask
              style={{
                width: stepRectPos.width,
                height: stepRectPos.height,
                left: stepRectPos.left,
                top: stepRectPos.top,
              }}
            ></HelpMask>
          )}
        </Mask>
      )}

      {showGuide && step >= 1 && (
        <AnchorElement list={anchorRectPosList} step={step} />
      )}
      {stepRectPos?.width >= 0 &&
        showGuide &&
        GUIDE_STEPS[step]?.popover(stepRectPos)}
    </>
  )
}
